import { DocumentsState, PersonalDocuments, SponsorDocuments } from './state';
import { mutation, MicroserviceEnum } from '@/helpers/westeros';
import RootState from '@/store/root_state';
import { ActionTree } from 'vuex';
import {
  uploadFinancialSponsorDocument,
  UploadDocumentMutationResult,
  uploadStudentDocument,
} from '@/store/graphql/mutations/westeros-mutations-upload-documents';

const actions: ActionTree<DocumentsState, RootState> = {
  async UPDATE_PERSONAL_DOCUMENTS(
    { dispatch },
    payload: { personalDocuments: PersonalDocuments },
  ): Promise<void> {
    const docs = Object.entries(payload.personalDocuments);
    try {
      for (let i = 0; i < docs.length; i++) {
        const doc = docs[i];
        // ref: https://eslint.org/docs/rules/no-await-in-loop#when-not-to-use-it
        // eslint-disable-next-line no-await-in-loop
        await mutation<UploadDocumentMutationResult>(
          MicroserviceEnum.ARCANEUM,
          uploadStudentDocument,
          {
            fileName: doc[1].fileName,
            documentType: doc[0],
            documentDataUrl: doc[1].fileDataUrl,
          },
        );
      }
    } catch (error) {
      throw new Error(`Failed to update personal documents: ${error}`);
    }
  },

  async UPDATE_SPONSOR_DOCUMENTS(
    { dispatch },
    payload: { sponsorDocuments: SponsorDocuments },
  ): Promise<void> {
    const docs = Object.entries(payload.sponsorDocuments);
    try {
      for (let i = 0; i < docs.length; i++) {
        const doc = docs[i];
        // ref: https://eslint.org/docs/rules/no-await-in-loop#when-not-to-use-it
        // eslint-disable-next-line no-await-in-loop
        await mutation<UploadDocumentMutationResult>(
          MicroserviceEnum.ARCANEUM,
          uploadFinancialSponsorDocument,
          {
            fileName: doc[1].fileName,
            documentType: doc[0],
            documentDataUrl: doc[1].fileDataUrl,
          },
        );
      }
    } catch (error) {
      throw new Error(`Failed to update sponsor documents: ${error}`);
    }
  },
};

export default actions;
